import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { BaseInput } from './BaseInput';
export const NumberInput = forwardRef((_a, ref) => {
    var { labelPosition = 'top', variant = 'normal', width = '100%' } = _a, props = __rest(_a, ["labelPosition", "variant", "width"]);
    return (_jsx(BaseInput, Object.assign({}, props, { labelPosition: labelPosition, ref: ref, type: "number", variant: variant, width: width })));
});
//# sourceMappingURL=NumberInput.js.map